import { BULK_UPLOAD_TYPE_ID } from '../../TypeOfCharge.types';
import './HistoryAction.scss';

interface IHistoryAction {
  action: (value: BULK_UPLOAD_TYPE_ID) => void;
  label: string;
  value: BULK_UPLOAD_TYPE_ID;
  isActive: boolean;
}

const HistoryAction = ({ action, label, value, isActive }: IHistoryAction) => {
  return (
    <button type="button" className={`historyAction ${isActive ? 'active' : ''}`} onClick={() => action(value)}>
      {label}
    </button>
  );
};

export default HistoryAction;
